import React, { useState } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { Modal, Paragraph, Button } from 'bambus-ui-components-x';
import { media } from 'styled-bootstrap-grid';

type RestartOnboardingModalProps = {
  isModalVisible: boolean;
  onCloseModal: () => any;
  onContinueApplication: () => any;
  onRestartOnboarding: () => Promise<any>;
};

const StyledWrapper = styled(Modal.Wrapper)`
  min-width: 300px;
  ${media.lg`
    min-width: 750px;
  `}
`;

const ButtonsWrapper = styled.div`
  // emulating gap
  --gap: 20px;
  display: flex;
  flex-wrap: wrap;
  margin: calc(-1 * var(--gap)) 0 0 calc(-1 * var(--gap));
  width: calc(100% + var(--gap));

  // this needs 2x specificity thus the 2 "&" as we're manipulating the Button components
  && > * {
    margin: var(--gap) 0 0 var(--gap);
  }

  & > * {
    flex: 1;
  }

  ${media.lg`
    & > * {
      flex: 0;
    }
  `}
`;

const RestartOnboardingModal = ({
  isModalVisible,
  onCloseModal,
  onContinueApplication,
  onRestartOnboarding: onRestartOnboardingProp,
}: RestartOnboardingModalProps) => {
  const [isRestartInProgress, setIsRestartInProgress] = useState(false);

  const onRestartOnboarding = async () => {
    setIsRestartInProgress(true);
    await onRestartOnboardingProp();
    setIsRestartInProgress(false);
  };

  return (
    <StyledWrapper
      isOpen={isModalVisible}
      style={{
        overlay: {
          zIndex: 10,
        },
      }}
    >
      <Modal.CloseButton onClick={onCloseModal} />
      <Modal.Content>
        <Modal.Header tag="h4" size={3}>
          <FormattedMessage id="restartOnboardingPrompt.header" />
        </Modal.Header>
        <Paragraph large>
          <FormattedMessage id="restartOnboardingPrompt.paragraph1" />
        </Paragraph>
        <Paragraph large>
          <span style={{ fontWeight: 'bold' }}>
            <FormattedMessage id="restartOnboardingPrompt.warning" />
          </span>
          <FormattedMessage id="restartOnboardingPrompt.warningParagraph" />
        </Paragraph>
        <ButtonsWrapper>
          <Button
            outline
            onClick={onRestartOnboarding}
            disabled={isRestartInProgress}
          >
            <FormattedMessage id="restartOnboardingPrompt.buttonRestart" />
          </Button>
          <Button
            muted
            onClick={onContinueApplication}
            disabled={isRestartInProgress}
          >
            <FormattedMessage id="restartOnboardingPrompt.buttonContinue" />
          </Button>
        </ButtonsWrapper>
      </Modal.Content>
    </StyledWrapper>
  );
};

export default RestartOnboardingModal;
